<template lang="pug">
  .flex.flex-row.justify-between.relative.font-700
    
    .bg-grey-d5.h-4.w-full.absolute.top-24()
      .h-4.progress-bar.bg-main-0.transition-all.duration-200(role="progressbar"  :style="progress")
      //aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
    .text-center.z-10.flex.flex-col.items-center.relative(v-for="(item, i) in stepInfo" :key="i" @click="clickStep(item,i)")
      .bg-main-0.w-48.h-48.border-3.border-main-0.text-grey-op06.rounded-50.leading-48(
        :class="{'border-grey-d5': i > currentStep  ,'bg-white': i > currentStep, 'text-white' : i <= currentStep, 'cursor-pointer' :   !item.disable}"
        :id="'step-'+(i+1)") 
          //&&  item.disable
          iCon.h-44.w-44.text-white(iconClass="Ico_Check" type="svg" v-if="i < currentStep")
          .text-30(v-if="i >= currentStep") {{i+1}}
      .absolute.top-46.min-w-200.pt-16.font-600.text-16.text-main-0(class="-bottom-40" :class="{ 'text-grey-op06' : i > currentStep}") {{item.title}}



</template>

<script>


export default {
  name: 'Stepper',
  components: {
    // Button,
  },
  props: {
    type: String,
    currentStep: {
      type: Number,
      // required: true,
      default: 0
    },
    stepInfo: {
      type: Array,
      // required: true,
      default: () => [
        // {
        //   title: 'Update Setting',
        //   value:'step1',
        //   disable: true,
        //   selected: true,
        // },
        // {
        //   title: 'Update Filter',
        //   value:'step2',
        //   disable: true,
        //   selected: false,
        // },
        // {
        //   title: 'Export',
        //   value:'step3',
        //   disable: false,
        //   selected: false,
        // },
      ]
    },

    
  },
  data() {
    return {
      isShow: this.show,
    };
  },
  mounted(){
    
  },
  methods: {
    clickStep(item,i){
      // console.log('?????',item,i)
      if(item.disable) return
      this.$emit('changeStep', {item: item, index :i});
    },

  },
  computed: {
    progress () { 
      if(this.currentStep > this.stepInfo.length) {
        return `width: 100%`
      }
      else{
        const first = document.getElementById('step-1');
        const current = document.getElementById(`step-${this.currentStep+1}`);
        
        if (first && current) {
          const delta = current.getBoundingClientRect().right -first.getBoundingClientRect().right;
          return `width: ${delta}px;`;
        }else{
          return `width: 0px`
        }
      }
    }
    
  },
  watch:{

  }
};
</script>

<style lang="scss" scoped>

.aaaaa{
  // border: solid 1px red;
  // transform: translate(0, 50%);
}

// .bbbbbb{
//   transform: translate(0, 50%);
// }

</style>